/**
 * Controlled wind-down constants (pre-shutdown).
 *
 * The product is closing down. Existing subscribers keep full access until the
 * shutdown date with no further charges; new signups / purchases / free usage
 * are blocked. We're moving users to our new product.
 */

/** Hard end of available usage — the service fully shuts down on this date. */
export const SHUTDOWN_DATE = "2026-07-10";

/** New product we're moving to. */
export const NEW_PRODUCT_URL = "https://makepodcast.app/";
export const NEW_PRODUCT_NAME = "makepodcast.app";
